import { Component, OnInit } from '@angular/core';
import { MemberQuery } from '@fgb/core';
import { map } from 'rxjs/operators';

@Component({
  selector: 'fgb-account-details-page',
  templateUrl: './account-details-page.component.html',
  styleUrls: ['./account-details-page.component.scss'],
})
export class AccountDetailsPageComponent implements OnInit {
  name$: string;

  constructor(private memberQuery: MemberQuery) {}

  ngOnInit() {
    this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
      if (m) {
        return `${m.FirstName} ${m.Surname}`;
      }
      return '';
      })
    ).subscribe((name) => {
      this.name$ = name;
    });
  }
  
}
